export default __webpack_public_path__ + "static/media/group-option-female-unselected.6903ccda.svg";